// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container with a modern, subtle gradient background */
.custom-dashboard-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
}

/* === HEADER === */
.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 3rem;
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
    position: sticky;
    top: 0;
    z-index: 10;
}

.header-left,
.header-right,
.header-center {
    flex: 1 1;
}

.header-left {
    display: flex;
    justify-content: flex-start;
}

.header-center {
    display: flex;
    justify-content: center;
}

.header-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 2.5rem;
}

.user-profile-section {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    white-space: nowrap;
}

.datetime-display {
    font-size: 1.2rem;
    color: #475569;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.logo-placeholder {
    height: 65px;
    width: 65px;
    background: linear-gradient(135deg, #fbd38d 0%, #f6ad55 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(246, 173, 85, 0.3);
}

.center-logo {
    height: 100%;
    width: 100%;
    object-fit: contain;
    border-radius: 50%;
}

.welcome-text {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
}

.icon-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #64748b;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    padding: 0.5rem;
    border-radius: 50%;
}

.icon-btn:hover {
    color: #2563eb;
    background-color: #f1f5f9;
}

.logout-btn:hover {
    color: #ef4444;
    background-color: #fef2f2;
}

.badge {
    position: absolute;
    top: 0px;
    right: 0px;
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    height: 20px;
    min-width: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
}

/* === NOTIFICATION MODAL === */
.notification-wrapper {
    position: relative;
}

.notification-modal {
    position: absolute;
    top: calc(100% + 15px);
    right: -10px;
    width: 340px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(226, 232, 240, 0.8);
    overflow: hidden;
    z-index: 50;
    animation: slideDown 0.2s ease-out forwards;
    transition: width 0.3s ease;
}

.notification-modal.expanded {
    width: 420px;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.notif-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    background: #f8fafc;
}

.notif-header h4 {
    margin: 0;
    font-size: 1rem;
    color: #1e293b;
    font-weight: 600;
}

.notif-count {
    background: #ef4444;
    color: white;
    font-size: 0.75rem;
    padding: 0.2rem 0.6rem;
    border-radius: 99px;
    font-weight: 600;
}

.notif-body {
    max-height: 320px;
    overflow-y: auto;
    transition: max-height 0.3s ease;
}

.notif-body.expanded-body {
    max-height: 480px;
}

.notif-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    color: #94a3b8;
}

.empty-bell {
    margin-bottom: 0.75rem;
    opacity: 0.4;
}

.notif-empty p {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 500;
}

.notif-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.notif-item {
    display: flex;
    gap: 1rem;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.2s;
}

.notif-item:hover {
    background: #f8fafc;
}

.notif-item.unread {
    background: #f0fdf4;
}

.notif-item.unread:hover {
    background: #eefbf3;
}

.notif-icon {
    height: 36px;
    width: 36px;
    border-radius: 50%;
    background: #e0e7ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.notif-content {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.notif-title {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #1e293b;
}

.notif-desc {
    margin: 0;
    font-size: 0.85rem;
    color: #64748b;
    line-height: 1.4;
}

.notif-time {
    font-size: 0.75rem;
    color: #94a3b8;
    margin-top: 0.25rem;
    font-weight: 500;
}

.notif-footer {
    padding: 0.75rem;
    text-align: center;
    font-size: 0.9rem;
    color: #2563eb;
    font-weight: 600;
    cursor: pointer;
    background: #f8fafc;
    border-top: 1px solid #f1f5f9;
    transition: all 0.2s;
}

.notif-footer:hover {
    background: #f1f5f9;
    text-decoration: underline;
}

.notif-pagination-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1.25rem;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
}

.page-btn {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    background: white;
    border: 1px solid #cbd5e1;
    color: #475569;
    padding: 0.4rem 0.75rem;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    background: #f1f5f9;
    color: #1e293b;
    border-color: #94a3b8;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f8fafc;
}

.page-info {
    font-size: 0.85rem;
    color: #64748b;
    font-weight: 500;
}

/* === MAIN CONTENT (Updated for stacking) === */
.dashboard-main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    /* Changed to allow vertical stacking */
    align-items: center;
    justify-content: center;
    padding: 3rem;
    gap: 3rem;
    /* Space between Pending Actions and Grid */
}

/* === PENDING ACTIONS SECTION (NEW) === */
.pending-actions-container {
    width: 100%;
    max-width: 1220px;
    /* Matches grid max width */
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 4px 15px -3px rgba(245, 158, 11, 0.1);
}

.pending-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
}

.text-amber {
    color: #d97706;
}

.text-blue {
    color: #2563eb;
}

.text-emerald {
    color: #059669;
}

.pending-header h2 {
    margin: 0;
    color: #92400e;
    font-size: 1.4rem;
    font-weight: 700;
}

.pending-cards-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.pending-action-card {
    background: white;
    border-radius: 12px;
    padding: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #fcd34d;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.pending-action-info h4 {
    margin: 0 0 0.5rem 0;
    font-size: 1.15rem;
    color: #1e293b;
    font-weight: 700;
}

.pending-action-info p {
    margin: 0;
    color: #475569;
    font-size: 1rem;
    line-height: 1.5;
}

.pending-action-info strong {
    color: #1e293b;
}

.btn-confirm-tx {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #10b981;
    color: white;
    border: none;
    padding: 0.85rem 1.5rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.btn-confirm-tx:hover:not(:disabled) {
    background: #059669;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);
}

.btn-confirm-tx:disabled {
    background: #6ee7b7;
    cursor: not-allowed;
}


/* === CROSS LAYOUT GRID === */
.cross-layout-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(320px, 380px));
    grid-template-rows: repeat(3, minmax(240px, auto));
    gap: 2.5rem;
    width: 100%;
    justify-content: center;
}

.card-amount {
    grid-area: 1 / 2 / 2 / 3;
}

.card-groups {
    grid-area: 2 / 1 / 3 / 2;
}

.card-request {
    grid-area: 2 / 2 / 3 / 3;
}

.card-passbook {
    grid-area: 2 / 3 / 3 / 4;
}

.card-bidding {
    grid-area: 3 / 2 / 4 / 3;
}

.layout-card {
    background: white;
    border-radius: 24px;
    padding: 2.5rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01);
    border: 1px solid rgba(255, 255, 255, 0.5);
}

.layout-card:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 25px 35px -5px rgba(0, 0, 0, 0.08), 0 15px 15px -10px rgba(0, 0, 0, 0.04);
}

.card-amount {
    background: linear-gradient(145deg, #ffffff 0%, #f0fdf4 100%);
}

.card-groups {
    background: linear-gradient(145deg, #ffffff 0%, #eff6ff 100%);
}

.card-request {
    background: linear-gradient(145deg, #ffffff 0%, #e0e7ff 100%);
    border: 2px solid #c7d2fe;
}

.card-passbook {
    background: linear-gradient(145deg, #ffffff 0%, #faf5ff 100%);
}

.card-bidding {
    background: linear-gradient(145deg, #ffffff 0%, #fffbeb 100%);
}

.icon-wrapper {
    height: 70px;
    width: 70px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.card-amount .icon-wrapper {
    color: #f59e0b;
}

.card-groups .icon-wrapper {
    color: #3b82f6;
}

.card-request .icon-wrapper {
    color: #4f46e5;
    background: white;
}

.card-passbook .icon-wrapper {
    color: #8b5cf6;
}

.card-bidding .icon-wrapper {
    color: #f59e0b;
}

.layout-card h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 700;
}

.card-value {
    font-size: 2.2rem;
    font-weight: 800;
    color: #059669;
    margin: 0.5rem 0;
    letter-spacing: -1px;
}

.card-hint {
    font-size: 0.95rem;
    color: #64748b;
    font-weight: 500;
}

/* === FOOTER ADS === */
.dashboard-footer {
    background: white;
    padding: 1rem 1.5rem;
    border-top: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.02);
}

.marquee-container {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}

.marquee-content {
    display: inline-block;
    color: #334155;
    text-decoration: none;
    font-weight: 600;
    font-size: 1.05rem;
    padding-left: 100%;
    animation: scroll-left 30s linear infinite;
}

.marquee-content:hover {
    color: #2563eb;
    text-decoration: underline;
    animation-play-state: paused;
}

@keyframes scroll-left {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
}

@media (max-width: 1200px) {
    .cross-layout-grid {
        grid-template-columns: repeat(3, minmax(250px, 1fr));
        gap: 1.5rem;
    }
}

@media (max-width: 950px) {
    .dashboard-main {
        padding: 1.5rem;
    }

    .cross-layout-grid {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-template-rows: auto;
    }

    .card-amount,
    .card-groups,
    .card-request,
    .card-passbook,
    .card-bidding {
        grid-area: auto;
    }

    .dashboard-header {
        flex-direction: column;
        gap: 1.5rem;
        text-align: center;
        padding: 1.5rem;
    }

    .header-left,
    .header-center,
    .header-right {
        justify-content: center;
        width: 100%;
    }

    .header-right {
        gap: 1.5rem;
    }

    .notification-modal,
    .notification-modal.expanded {
        right: auto;
        width: 90vw;
    }

    .pending-action-card {
        flex-direction: column;
        text-align: center;
        gap: 1.5rem;
    }

    .btn-confirm-tx {
        width: 100%;
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/member/Dashboard.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;AACxB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;IAC3C,2BAA2B;IAC3B,iDAAiD;IACjD,0CAA0C;IAC1C,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;;;IAGI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,6DAA6D;IAC7D,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iDAAiD;IACjD,0CAA0C;IAC1C,gBAAgB;IAChB,WAAW;IACX,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,gDAAgD;AAChD;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,2CAA2C;AAC/C;;AAEA,0CAA0C;AAC1C;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA,8BAA8B;AAC9B;IACI,aAAa;IACb,sDAAsD;IACtD,kDAAkD;IAClD,WAAW;IACX,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,4DAA4D;IAC5D,qFAAqF;IACrF,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,uFAAuF;AAC3F;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;IAC7D,yBAAyB;AAC7B;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,iBAAiB;IACjB,oBAAoB;IACpB,8CAA8C;IAC9C,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,oDAAoD;QACpD,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,2DAA2D;QAC3D,wBAAwB;IAC5B;;IAEA;;;;;QAKI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;;IAEA;;;QAGI,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ","sourcesContent":["/* Container with a modern, subtle gradient background */\n.custom-dashboard-container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n}\n\n/* === HEADER === */\n.dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.5rem 3rem;\n    background-color: rgba(255, 255, 255, 0.85);\n    backdrop-filter: blur(10px);\n    border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.header-left,\n.header-right,\n.header-center {\n    flex: 1;\n}\n\n.header-left {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.header-center {\n    display: flex;\n    justify-content: center;\n}\n\n.header-right {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 2.5rem;\n}\n\n.user-profile-section {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    white-space: nowrap;\n}\n\n.datetime-display {\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n\n.logo-placeholder {\n    height: 65px;\n    width: 65px;\n    background: linear-gradient(135deg, #fbd38d 0%, #f6ad55 100%);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 10px rgba(246, 173, 85, 0.3);\n}\n\n.center-logo {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n    border-radius: 50%;\n}\n\n.welcome-text {\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: #1e293b;\n}\n\n.icon-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #64748b;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    padding: 0.5rem;\n    border-radius: 50%;\n}\n\n.icon-btn:hover {\n    color: #2563eb;\n    background-color: #f1f5f9;\n}\n\n.logout-btn:hover {\n    color: #ef4444;\n    background-color: #fef2f2;\n}\n\n.badge {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    background: linear-gradient(135deg, #ef4444, #dc2626);\n    color: white;\n    font-size: 0.75rem;\n    font-weight: bold;\n    height: 20px;\n    min-width: 20px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid white;\n}\n\n/* === NOTIFICATION MODAL === */\n.notification-wrapper {\n    position: relative;\n}\n\n.notification-modal {\n    position: absolute;\n    top: calc(100% + 15px);\n    right: -10px;\n    width: 340px;\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.15);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    overflow: hidden;\n    z-index: 50;\n    animation: slideDown 0.2s ease-out forwards;\n    transition: width 0.3s ease;\n}\n\n.notification-modal.expanded {\n    width: 420px;\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.notif-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #f1f5f9;\n    background: #f8fafc;\n}\n\n.notif-header h4 {\n    margin: 0;\n    font-size: 1rem;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.notif-count {\n    background: #ef4444;\n    color: white;\n    font-size: 0.75rem;\n    padding: 0.2rem 0.6rem;\n    border-radius: 99px;\n    font-weight: 600;\n}\n\n.notif-body {\n    max-height: 320px;\n    overflow-y: auto;\n    transition: max-height 0.3s ease;\n}\n\n.notif-body.expanded-body {\n    max-height: 480px;\n}\n\n.notif-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 3rem 1rem;\n    color: #94a3b8;\n}\n\n.empty-bell {\n    margin-bottom: 0.75rem;\n    opacity: 0.4;\n}\n\n.notif-empty p {\n    margin: 0;\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n\n.notif-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.notif-item {\n    display: flex;\n    gap: 1rem;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.2s;\n}\n\n.notif-item:hover {\n    background: #f8fafc;\n}\n\n.notif-item.unread {\n    background: #f0fdf4;\n}\n\n.notif-item.unread:hover {\n    background: #eefbf3;\n}\n\n.notif-icon {\n    height: 36px;\n    width: 36px;\n    border-radius: 50%;\n    background: #e0e7ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.notif-content {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.notif-title {\n    margin: 0;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.notif-desc {\n    margin: 0;\n    font-size: 0.85rem;\n    color: #64748b;\n    line-height: 1.4;\n}\n\n.notif-time {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    margin-top: 0.25rem;\n    font-weight: 500;\n}\n\n.notif-footer {\n    padding: 0.75rem;\n    text-align: center;\n    font-size: 0.9rem;\n    color: #2563eb;\n    font-weight: 600;\n    cursor: pointer;\n    background: #f8fafc;\n    border-top: 1px solid #f1f5f9;\n    transition: all 0.2s;\n}\n\n.notif-footer:hover {\n    background: #f1f5f9;\n    text-decoration: underline;\n}\n\n.notif-pagination-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 1.25rem;\n    background: #f8fafc;\n    border-top: 1px solid #e2e8f0;\n}\n\n.page-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    color: #475569;\n    padding: 0.4rem 0.75rem;\n    border-radius: 6px;\n    font-size: 0.85rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.page-btn:hover:not(:disabled) {\n    background: #f1f5f9;\n    color: #1e293b;\n    border-color: #94a3b8;\n}\n\n.page-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background: #f8fafc;\n}\n\n.page-info {\n    font-size: 0.85rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n/* === MAIN CONTENT (Updated for stacking) === */\n.dashboard-main {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    /* Changed to allow vertical stacking */\n    align-items: center;\n    justify-content: center;\n    padding: 3rem;\n    gap: 3rem;\n    /* Space between Pending Actions and Grid */\n}\n\n/* === PENDING ACTIONS SECTION (NEW) === */\n.pending-actions-container {\n    width: 100%;\n    max-width: 1220px;\n    /* Matches grid max width */\n    background: #fffbeb;\n    border: 1px solid #fde68a;\n    border-radius: 20px;\n    padding: 2rem;\n    box-shadow: 0 4px 15px -3px rgba(245, 158, 11, 0.1);\n}\n\n.pending-header {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n}\n\n.text-amber {\n    color: #d97706;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n.text-emerald {\n    color: #059669;\n}\n\n.pending-header h2 {\n    margin: 0;\n    color: #92400e;\n    font-size: 1.4rem;\n    font-weight: 700;\n}\n\n.pending-cards-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.pending-action-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid #fcd34d;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.pending-action-info h4 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1.15rem;\n    color: #1e293b;\n    font-weight: 700;\n}\n\n.pending-action-info p {\n    margin: 0;\n    color: #475569;\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.pending-action-info strong {\n    color: #1e293b;\n}\n\n.btn-confirm-tx {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: #10b981;\n    color: white;\n    border: none;\n    padding: 0.85rem 1.5rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n}\n\n.btn-confirm-tx:hover:not(:disabled) {\n    background: #059669;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);\n}\n\n.btn-confirm-tx:disabled {\n    background: #6ee7b7;\n    cursor: not-allowed;\n}\n\n\n/* === CROSS LAYOUT GRID === */\n.cross-layout-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(320px, 380px));\n    grid-template-rows: repeat(3, minmax(240px, auto));\n    gap: 2.5rem;\n    width: 100%;\n    justify-content: center;\n}\n\n.card-amount {\n    grid-area: 1 / 2 / 2 / 3;\n}\n\n.card-groups {\n    grid-area: 2 / 1 / 3 / 2;\n}\n\n.card-request {\n    grid-area: 2 / 2 / 3 / 3;\n}\n\n.card-passbook {\n    grid-area: 2 / 3 / 3 / 4;\n}\n\n.card-bidding {\n    grid-area: 3 / 2 / 4 / 3;\n}\n\n.layout-card {\n    background: white;\n    border-radius: 24px;\n    padding: 2.5rem 2rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01);\n    border: 1px solid rgba(255, 255, 255, 0.5);\n}\n\n.layout-card:hover {\n    transform: translateY(-10px) scale(1.02);\n    box-shadow: 0 25px 35px -5px rgba(0, 0, 0, 0.08), 0 15px 15px -10px rgba(0, 0, 0, 0.04);\n}\n\n.card-amount {\n    background: linear-gradient(145deg, #ffffff 0%, #f0fdf4 100%);\n}\n\n.card-groups {\n    background: linear-gradient(145deg, #ffffff 0%, #eff6ff 100%);\n}\n\n.card-request {\n    background: linear-gradient(145deg, #ffffff 0%, #e0e7ff 100%);\n    border: 2px solid #c7d2fe;\n}\n\n.card-passbook {\n    background: linear-gradient(145deg, #ffffff 0%, #faf5ff 100%);\n}\n\n.card-bidding {\n    background: linear-gradient(145deg, #ffffff 0%, #fffbeb 100%);\n}\n\n.icon-wrapper {\n    height: 70px;\n    width: 70px;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n    background: rgba(255, 255, 255, 0.6);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n.card-amount .icon-wrapper {\n    color: #f59e0b;\n}\n\n.card-groups .icon-wrapper {\n    color: #3b82f6;\n}\n\n.card-request .icon-wrapper {\n    color: #4f46e5;\n    background: white;\n}\n\n.card-passbook .icon-wrapper {\n    color: #8b5cf6;\n}\n\n.card-bidding .icon-wrapper {\n    color: #f59e0b;\n}\n\n.layout-card h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 700;\n}\n\n.card-value {\n    font-size: 2.2rem;\n    font-weight: 800;\n    color: #059669;\n    margin: 0.5rem 0;\n    letter-spacing: -1px;\n}\n\n.card-hint {\n    font-size: 0.95rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n/* === FOOTER ADS === */\n.dashboard-footer {\n    background: white;\n    padding: 1rem 1.5rem;\n    border-top: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.02);\n}\n\n.marquee-container {\n    width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.marquee-content {\n    display: inline-block;\n    color: #334155;\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 1.05rem;\n    padding-left: 100%;\n    animation: scroll-left 30s linear infinite;\n}\n\n.marquee-content:hover {\n    color: #2563eb;\n    text-decoration: underline;\n    animation-play-state: paused;\n}\n\n@keyframes scroll-left {\n    0% {\n        transform: translateX(0);\n    }\n\n    100% {\n        transform: translateX(-100%);\n    }\n}\n\n@media (max-width: 1200px) {\n    .cross-layout-grid {\n        grid-template-columns: repeat(3, minmax(250px, 1fr));\n        gap: 1.5rem;\n    }\n}\n\n@media (max-width: 950px) {\n    .dashboard-main {\n        padding: 1.5rem;\n    }\n\n    .cross-layout-grid {\n        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n        grid-template-rows: auto;\n    }\n\n    .card-amount,\n    .card-groups,\n    .card-request,\n    .card-passbook,\n    .card-bidding {\n        grid-area: auto;\n    }\n\n    .dashboard-header {\n        flex-direction: column;\n        gap: 1.5rem;\n        text-align: center;\n        padding: 1.5rem;\n    }\n\n    .header-left,\n    .header-center,\n    .header-right {\n        justify-content: center;\n        width: 100%;\n    }\n\n    .header-right {\n        gap: 1.5rem;\n    }\n\n    .notification-modal,\n    .notification-modal.expanded {\n        right: auto;\n        width: 90vw;\n    }\n\n    .pending-action-card {\n        flex-direction: column;\n        text-align: center;\n        gap: 1.5rem;\n    }\n\n    .btn-confirm-tx {\n        width: 100%;\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
